// P2b tanda 2b — item 3: la descripción larga se edita y se ve SIN HTML crudo.
// parseDescription: HTML → partes limpias (párrafo/detalles/cierre) si mapea a la
// plantilla; si no, lo marca no-mapeable y da el texto plano (preservando el original).
// descriptionToText: HTML → texto legible (nunca etiquetas). textToHtml: texto → <p>.

const BULLET = String.fromCharCode(1); // marcador interno de viñeta (no aparece en HTML real)

function decodeEntities(s) {
  return String(s || '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'");
}

// HTML → texto legible. Listas como "• item". Nunca devuelve < ni >.
export function descriptionToText(html) {
  const txt = String(html || '')
    .replace(/<\s*li[^>]*>/gi, BULLET)
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\/\s*(p|li|ul|ol|h[1-6]|div|tr)\s*>/gi, '\n')
    .replace(/<[^>]*>/g, '');           // strip del resto de etiquetas
  return decodeEntities(txt)
    .replace(/[<>]/g, '')               // por si quedó algún ángulo suelto
    .split('\n')
    .map((l) => l.split(BULLET).join('• ').trim())
    .filter(Boolean)
    .join('\n')
    .trim();
}

// Texto plano → HTML por párrafos (línea en blanco = nuevo <p>).
export function textToHtml(text) {
  const paras = String(text || '').split(/\n\s*\n/).map((s) => s.trim()).filter(Boolean);
  return paras.map((p) => `<p>${p}</p>`).join('\n');
}

// Intenta mapear el HTML a la forma de la plantilla (párrafo + <ul><li> + cierre).
// Mapeable solo si el HTML usa exclusivamente <p>/<ul>/<li> (sin atributos ni
// otras etiquetas). Si no, { mappable:false } + texto plano preservando el original.
export function parseDescription(html) {
  const clean = String(html || '').trim();
  if (!clean) return { mappable: true, parrafo: '', detalles: [], cierre: '', plain: '' };

  const soloPermitidas = clean.replace(/<\/?(p|ul|li)>/gi, '');
  if (/<[^>]+>/.test(soloPermitidas)) {
    return { mappable: false, parrafo: '', detalles: [], cierre: '', plain: descriptionToText(clean) };
  }

  const ulMatch = clean.match(/<ul>([\s\S]*?)<\/ul>/i);
  const detalles = ulMatch
    ? [...ulMatch[1].matchAll(/<li>([\s\S]*?)<\/li>/gi)].map((m) => m[1].trim())
    : [];

  let parrafo = '';
  let cierre = '';
  if (ulMatch) {
    const idx = clean.indexOf(ulMatch[0]);
    const antes = clean.slice(0, idx);
    const despues = clean.slice(idx + ulMatch[0].length);
    const pAntes = [...antes.matchAll(/<p>([\s\S]*?)<\/p>/gi)].map((m) => m[1].trim());
    const pDespues = [...despues.matchAll(/<p>([\s\S]*?)<\/p>/gi)].map((m) => m[1].trim());
    parrafo = pAntes[0] || '';
    cierre = pDespues[0] || '';
  } else {
    const ps = [...clean.matchAll(/<p>([\s\S]*?)<\/p>/gi)].map((m) => m[1].trim());
    parrafo = ps[0] || '';
    cierre = ps[1] || '';
  }

  return { mappable: true, parrafo, detalles, cierre, plain: descriptionToText(clean) };
}
